/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { DpProductCardSearch } from '@/components/blocks/DpLibrary/DpProductCardSearch';
import { useProductEvents } from '@/data/Content/_ProductEvents';
import { calculateProductPriceIncrease } from '@/data/Content/BasicCheckOut/utils/calculateProductPriceIncrease';
import { ProductType } from '@/data/types/Product';
import { getImage } from '@/utils/getImage';
import { Grid } from '@mui/material';
import { formatPrice } from 'integration/utils/formatPrice';
import { FC } from 'react';

export const ProductCardSearch: FC<{
	product: ProductType;
	clickAction?: () => void;
}> = ({ product, clickAction }) => {
	const { onClick } = useProductEvents({ product });

	return (
		<Grid onClick={onClick(clickAction)} id={product.partNumber} data-testid={product.partNumber}>
			<DpProductCardSearch
				seo={product.seo.href}
				title={product.name}
				category={'Calzado Hombre'}
				image={getImage(product.thumbnail)}
				ribbons={product.ribbons}
				price={formatPrice(calculateProductPriceIncrease(product.productPrice.list || 0), 'mxn')}
				colors={['#C0474A', '#C46D52', '#242424']}
			/>
		</Grid>
	);
};
